<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-alert
        v-if="showMessageAlert"
        v-height-fade
        :variant="alertMessage.type"
        show
        dismissible
        fade
        class="mr-0"
      >
        <div class="alert-body">
          <span>{{ alertMessage.message }}</span>
        </div>
      </b-alert>

      <b-row v-if="!isLoading" class="justify-content-end">
        <b-col md="auto" class="d-flex justify-content-end">
          <b-button
            id="btn-verify"
            variant="info"
            size="sm"
            @click="verifyStatusSessionMethodManual"
            class="mr-2"
          >
            <font-awesome-icon icon="fa-solid fa-refresh" /> Verificación inmediata
            <b-tooltip target="btn-verify" placement="left">
              Verificar la sesión nuevamente y refrescar contador.
            </b-tooltip>
          </b-button>

          <b-button
            v-if="activeStatus.statusMessage != 'stopped'"
            id="btn-stop"
            variant="danger"
            size="sm"
            @click="stopVerifySession"
          >
            <font-awesome-icon icon="fa-solid fa-stop-circle" /> Detener verificación
            <b-tooltip target="btn-stop" placement="left">
              Detiene la verificación del servicio de la sesión actual.
            </b-tooltip>
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3 align-items-center justify-space-between">
        <b-col cols="6">
          <h4>Verificar sesión WhatsApp</h4>
        </b-col>

        <b-col cols="6" class="d-flex justify-content-end align-items-center">
          <h5 class="mb-0 mr-2">Estado</h5>
          <b-spinner
            v-if="activeStatus.statusMessage == 'online'" 
            key="success"
            variant="success"
            small
            type="grow"
            class="mr-2"
          />
          <b-spinner
            v-else-if="activeStatus.statusMessage == 'error'" 
            key="danger"
            variant="danger"
            small
            type="grow"
            class="mr-2"
          />
          <b-spinner
            v-else 
            key="warning"
            variant="warning"
            small
            type="grow"
            class="mr-2"
          />
          <p class="mb-0 mr-4">{{ activeStatus.statusMessage }}</p>

          <p
            class="mb-0"
            v-if="!isLoading && activeStatus.statusMessage != 'stopped'"
          >
            Verificando sesión en {{ counter }}
          </p>
        </b-col>
      </b-row>

      <b-overlay :show="isLoading" rounded="sm">
        <div v-if="activeStatus.statusMessage == 'online'">
          <b-row class="justify-content-center mt-4">
            <b-col cols="12" class="text-center">
              <h4 class="mb-4">¿Desea cerrar sesión en sus dispositivos?</h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="20rem" viewBox="0 0 450 512">
                <path fill="warning"
                  d="M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16m40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96zm72 72l12-36l36-12l-36-12l-12-36l-12 36l-36 12l36 12zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133M272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16s-7.2-16-16-16m-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16" />
                </svg>
            </b-col>
            <b-col cols="12" class="text-center mt-4 mb-2">
              <b-button 
                variant="danger" 
                @click="recreateWhatsappSessionQrMethod"
              >
                <font-awesome-icon icon="fa-solid fa-sign-out-alt" /> Cerrar Sesión
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-else-if="activeStatus.statusMessage == 'verifying'">
          <b-row class="justify-content-center mt-4 mb-2">
            <b-col cols="12" class="text-center">
              <h4 class="mb-4">Verificando Sesión...</h4>
              <b-spinner variant="primary"></b-spinner>
            </b-col>
          </b-row>
        </div>

        <div
          v-else-if="activeStatus.statusMessage == 'loading'"
          class="d-flex flex-column justify-content-center align-items-center mb-1"
          style="height: 60vh; width: 100%;"
        >
          <h4 class="mb-3">Creando QR...</h4>
          <b-img
            src="https://media.giphy.com/media/LWocZxVYEzl8Y3LWIZ/giphy.gif"
            alt="Loading"
            fluid
            style="max-width: 300px; border-radius: 12px;"
          />
        </div>

        <div v-else-if="activeStatus.statusMessage == 'stopped'">
          <b-row class="justify-content-center mt-4 mb-1">
            <b-col cols="12" class="text-center">
              <h4 class="mb-4">
                Para volver a verificar la sesión periódicamente haga click en el botón de verificación inmediata
              </h4>
              <font-awesome-icon 
                icon="fa-solid fa-stop-circle" 
                size="4x" 
                class="text-danger"
              />
            </b-col>
          </b-row>
        </div>

        <div v-else-if="activeStatus.statusMessage == 'authorize'">
          <b-row class="justify-content-center mt-4">
            <b-col cols="12" class="text-center">
              <h4 class="mb-4">
                Servicio en espera de autorización, escanee el QR para activarlo
              </h4>
            </b-col>
            <b-col md="6" class="mt-4">
              <b-list-group>
                <b-list-group-item>1. Abra la cámara del móvil</b-list-group-item>
                <b-list-group-item>2. Escanear el código QR</b-list-group-item>
                <b-list-group-item>3. Activar el servicio</b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col md="6" class="text-center">
              <b-card>
                <b-card-body>
                  <div v-html="qrGenerated"></div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <div v-else-if="activeStatus.statusMessage == 'conflict'">
          <b-row class="justify-content-center mt-4">
            <b-col cols="12" class="text-center">
              <h4 class="mb-4">
                Muchas sesiones activas. ¿Desea cerrar sesión en su dispositivo?
              </h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="20rem" viewBox="0 0 450 512">
                <path fill="warning"
                  d="M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16m40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96zm72 72l12-36l36-12l-36-12l-12-36l-12 36l-36 12l36 12zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133M272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16s-7.2-16-16-16m-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16" />
                </svg>
            </b-col>
            <b-col cols="12" class="text-center mt-4">
              <b-button 
                variant="danger" 
                @click="recreateWhatsappSessionQrMethod"
              >
                <font-awesome-icon icon="fa-solid fa-sign-out-alt" /> Cerrar Sesión
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-row class="justify-content-center mt-4">
            <b-col cols="12" class="text-center">
              <h5 class="mb-4">
                ¿Desea cerrar sesión en su dispositivo?
              </h5>
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="20rem" viewBox="0 0 450 512">
            <path fill="warning"
              d="M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16m40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96zm72 72l12-36l36-12l-36-12l-12-36l-12 36l-36 12l36 12zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133M272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16s-7.2-16-16-16m-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16" />
            </svg>
            </b-col>
            <b-col cols="12" class="text-center mt-4">
              <b-button 
                variant="danger" 
                @click="recreateWhatsappSessionQrMethod"
              >
                <font-awesome-icon icon="fa-solid fa-sign-out-alt" /> Cerrar Sesión
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card-code>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BTooltip,
  BRow,
  BCol,
  BImg,
  BSpinner,
  BEmbed, // Not used, BImg used for GIF
  BListGroup,
  BListGroupItem,
  BCard,
  BCardBody,
  BBadge,
  BOverlay
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { heightFade } from '@core/directives/animations'
import axios from '@axios'
import STATUS_RESPONSE from './whatsappConstants.js' // COOUNTER_INTERVAL and VERIFY_TIME_SESSION_INTERVAL moved to data

export default {
  components: {
    BAlert,
    BButton,
    BTooltip,
    BRow,
    BCol,
    BImg,
    BSpinner,
    BEmbed,
    BListGroup,
    BListGroupItem,
    BCard,
    BCardBody,
    BBadge,
    BOverlay,
    BCardCode,
    FontAwesomeIcon
  },
  directives: {
    heightFade,
  },
  data() {
    return {
      // Estados que estaban en el store
      activeStatus: {
        status: null,
        statusMessage: 'verifying' // 'online', 'verifying', 'loading', 'stopped', 'authorize', 'conflict'
      },
      alertMessage: {
        message: '',
        type: '' // 'info', 'danger', 'success', 'warning'
      },
      showMessageAlert: false,
      qrGenerated: '<svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="#fff"/><path d="M40 40h20v20H40zM80 40h20v20H80zM120 40h20v20h-20zM40 80h20v20H40zM120 80h20v20h-20zM40 120h20v20H40zM80 120h20v20H80zM120 120h20v20h-20z" fill="#000"/></svg>',
      counter: 30, // Initial counter value for display
      
      // Estados del componente para los intervalos
      intervalIdVerifySession: null,
      intervalIdCounter: null,
      isLoading: false,
      
      // Constantes de intervalos (ahora en data para mayor control)
      COOUNTER_INTERVAL: 1000, // 1 segundo
      VERIFY_TIME_SESSION_INTERVAL: 30000 // 30 segundos
    }
  },
  computed: {
    // ...mapState(useWhatsAppSession, [
    //   'activeStatus',
    //   'alertMessage',
    //   'showMessageAlert',
    //   'qrGenerated',
    //   'counter'
    // ])
  },
  methods: {
    // Método auxiliar para limpiar los intervalos
    clearTimers() {
      if (this.intervalIdVerifySession) {
        clearInterval(this.intervalIdVerifySession);
        this.intervalIdVerifySession = null;
      }
      if (this.intervalIdCounter) {
        clearInterval(this.intervalIdCounter);
        this.intervalIdCounter = null;
      }
    },
    
    // Método para resetear el contador de visualización
    resetCounter() {
      this.counter = this.VERIFY_TIME_SESSION_INTERVAL / 1000;
    },

    // Método que se ejecuta cada segundo para actualizar el contador
    updateCounter() {
      if (this.counter > 0 && this.activeStatus.statusMessage !== 'stopped') {
        this.counter--;
      } else if (this.counter <= 0 && this.activeStatus.statusMessage !== 'stopped') {
        // Cuando el contador llega a 0, se llama a la verificación
        // queryVerifyStatusSession ya se llama por el intervalIdVerifySession
        // Así que aquí solo aseguramos que el contador se resetea
        this.resetCounter();
      }
    },

    // Método para iniciar los intervalos de verificación y contador
    startVerifySessionInterval() {
      this.clearTimers(); // Asegurarse de limpiar cualquier intervalo previo
      
      // Iniciar el contador cada segundo
      this.intervalIdCounter = setInterval(this.updateCounter, this.COOUNTER_INTERVAL);
      
      // Iniciar la verificación de estado cada VERIFY_TIME_SESSION_INTERVAL (30 segundos)
      this.intervalIdVerifySession = setInterval(this.queryVerifyStatusSession, this.VERIFY_TIME_SESSION_INTERVAL);
      
      // Llamar a la verificación inmediatamente al iniciar
      this.queryVerifyStatusSession();
      
      this.resetCounter(); // Reiniciar el contador para empezar desde 30
      // Actualizar el statusMessage si estaba en 'stopped'
      if (this.activeStatus.statusMessage === 'stopped') {
        this.activeStatus.statusMessage = 'verifying'; // O el estado inicial que desees
      }
      this.alertMessage.message = "Verificación automática iniciada.";
      this.alertMessage.type = "info";
      this.showMessageAlert = true;
    },

    // Método para detener la verificación
    stopVerifySession() {
      this.$swal({
        icon: 'warning',
        title: 'Detener verificación',
        html: `¿Está seguro que desea detener la verificación automática de la sesión?`,
        showCancelButton: true,
        confirmButtonText: 'Sí, detener.',
        cancelButtonText: 'Cancelar.',
        confirmButtonColor: '#dc3545', // Color rojo para la acción de detener
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ml-1'
        },
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.clearTimers(); // Detener ambos intervalos
          this.activeStatus.statusMessage = 'stopped'; // Actualizar el estado a "detenido"
          this.alertMessage.message = "Verificación automática detenida. Haga click en 'Verificación inmediata' para reanudar.";
          this.alertMessage.type = "danger";
          this.showMessageAlert = true;
          this.counter = this.VERIFY_TIME_SESSION_INTERVAL / 1000; // Resetear el contador para mostrar 30
        }
      });
    },

    //Metodos adaptados (tu código original)
    queryVerifyStatusSession() {
      this.isLoading = true; // Mostrar overlay de carga
      axios.post('api', {
        query: `query SessionHealth {
            sessionHealth{
                status,
                message
            }
        }`,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.sessionHealth.status === 'success') {
            const message = response.data.data.sessionHealth.message;
            console.log(message);
            switch (message.trim()) {
                case STATUS_RESPONSE.STATUS_ONLINE:
                    this.alertMessage.message = "La sesión está online y operativa.";
                    this.alertMessage.type = "success";
                    this.activeStatus.status = true; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_CONFLICT:
                    this.alertMessage.message = "La sesión tiene un conflicto debido a que hay varias sesiones web de WhatsApp abiertas al mismo tiempo. Será necesario cerrar una sesión.";
                    this.alertMessage.type = "warning"; // Cambiado a warning para conflicto
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_ERROR:
                    this.alertMessage.message = "La sesión falló varias veces y no puede funcionar normalmente. Por favor contacte al soporte.";
                    this.alertMessage.type = "danger";
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_TIMEOUT:
                    this.alertMessage.message = " La sesión tiene un tiempo de espera de red persistente, generalmente porque el dispositivo perdió la conexión a Internet.";
                    this.alertMessage.type = "danger";
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_TIMEOUT_SYNC:
                    this.alertMessage.message = "La sesión no se puede sincronizar debido a problemas de red de conectividad del dispositivo o muchos chats abiertos (+1000) que requieren mucho tiempo.";
                    this.alertMessage.type = "danger";
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_OFFLINE:
                    this.alertMessage.message = "La sesión está fuera de línea y no se puede acceder a ella a través de la red. Suele ser un problema operativo.";
                    this.alertMessage.type = "danger";
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_AUTHORIZE:
                    // Si el servicio está caído o necesita autorización, genera el QR
                    this.alertMessage.message = "Generando código QR, este proceso puede tardar de 2 a 3 minutos, por favor volver a verificar pasado este tiempo para obtener el QR...";
                    this.alertMessage.type = "info";
                    this.activeStatus.status = false; 
                    this.activeStatus.statusMessage = "loading"; // Pone el estado en 'loading' para mostrar el GIF
                    this.queryScanWhatsappQr(); // Llama a la función para obtener el QR
                    break;
                case STATUS_RESPONSE.STATUS_AUTHORIZING:
                    this.alertMessage.message = "Autorizando...";
                    this.alertMessage.type = "info"; // Cambiado a info
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                case STATUS_RESPONSE.STATUS_BLOCKED:
                    this.alertMessage.message = "La sesión está bloqueada temporalmente debido a un problema inesperado. Por favor contacte al soporte.";
                    this.alertMessage.type = "danger";
                    this.activeStatus.status = null; 
                    this.activeStatus.statusMessage = message;
                    break;
                default:
                    this.alertMessage.message = `Estado desconocido: ${message}`;
                    this.alertMessage.type = "secondary";
                    break;
            }
            this.showMessageAlert = true;
          }
        }
      }).catch(error => {
          console.error("Error al verificar el estado de la sesión:", error);
          this.alertMessage.message = "Error al conectar con el servicio de verificación de sesión.";
          this.alertMessage.type = "danger";
          this.showMessageAlert = true;
          this.activeStatus.statusMessage = "error"; // Asegura que el estado visual refleje el error
      }).finally(() => {
          this.isLoading = false; // Ocultar overlay de carga
      });
    },

    queryScanWhatsappQr(){
      console.log('entro a query scan whatsapp')
      axios.post('api', {
        query: `query whatsappScanQr {
            whatsappScanQr{
                qr
                status
                message
            }
        }`,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.whatsappScanQr.status === 'success') {
            this.qrGenerated = response.data.data.whatsappScanQr.qr
            this.activeStatus.status = false 
            this.activeStatus.statusMessage= 'authorize' // Muestra el QR generado
          }
          console.log(response)
        }
      })
    },

    queryCloseSession(){
      axios.post('api', {
        query: `query WhatsappScanQr {
            WhatsappScanQr(forceService:true){
                qr
                status
                message
            }
        }`,
      }).then(response => {
        if (response.status === 200) {
          console.log(response)
        }
      })
    },

    queryRecreateSession(){
      this.isLoading = true;
      console.log("recrear sesion")
      axios.post('api', {
        query: `query recreateSession{
            recreateSession{
                status
                message
            }
        }`,
      }).then(response => {
        if (response.status === 200) {
          console.log(response)
          this.isLoading = false;
          setTimeout(() => {
            this.queryVerifyStatusSession()
          }, 2000);
        }
      })
    },

    verifyStatusSessionMethodManual(){
      this.$swal({
        icon: 'warning',
        title: 'Verificar sesión',
        html: `¿Está seguro que desea verificar la sesión nuevamente y refrescar el contador?`,
        showCancelButton: true,
        confirmButtonText: 'Sí, verificar.',
        cancelButtonText: 'Cancelar.',
        confirmButtonColor: '#d9534f',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-secondary ml-1'
        },
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.startVerifySessionInterval(); // Esto reinicia el ciclo de verificación y el contador
        }
      })
    },

    recreateWhatsappSessionQrMethod() {
      this.$swal({
        icon: 'warning',
        title: 'Cerrar sesión',
        html: `
          ¿Está seguro que desea cerrar sesión?<br><br>
          <h4>
            Esta acción hará que el dispositivo no funcione durante al menos 2 o 3 minutos.<br>
            Se requerirá autorización QR de sesión para que el dispositivo vuelva a estar operativo.
          </h4>
        `,
        showCancelButton: true,
        confirmButtonText: 'Sí, cerrar.',
        cancelButtonText: 'Cancelar.',
        confirmButtonColor: '#4CAF50',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-secondary ml-1'
        },
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {          
          this.queryRecreateSession()
        }
      });
    },
  },
  mounted() {
    // Al montar el componente, iniciamos la verificación automática
    this.startVerifySessionInterval();
  },
  beforeDestroy() {
    // Es crucial limpiar los intervalos antes de destruir el componente
    // para evitar fugas de memoria y que sigan ejecutándose en segundo plano.
    this.clearTimers();
  }
}
</script>

<style>
.principal .card-header {
  display: none !important
}
.principal .card-body {
  padding-bottom: 0 !important;
  margin: 0 !important;
}
</style>